
/* @flow */

import { route } from 'preact-router';
import {
    LIMPAR_PEDIDO,
    CARREGAR_PEDIDO,
    type LimparPedidoAction,
    type CarregarPedidoAction, getCliente,
} from './pedido';
import { type StateCliente } from './types';
import { type GetState, type State } from '../../preact-app/types';
import { type Usuario } from '../../usuario/types';
import getPrimeiroNome from '../../usuario/get-primeiro-nome';

export type SelecionarClienteAction = {
    type: 'balcao/cliente/SELECIONAR_CLIENTE',
    cliente: Usuario,
};

type ClienteAction =
    | LimparPedidoAction
    | CarregarPedidoAction
    | SelecionarClienteAction;

// Action Types

export const SELECIONAR_CLIENTE = 'balcao/cliente/SELECIONAR_CLIENTE';

// Utils

const getClientePorId = (state: State, id: number) => (
    state.balcao.gridClientes.itens.find(cliente => cliente.id === id)
);

// Action Creators

export const selecionarCliente = (cliente: Usuario) => ({
    type: SELECIONAR_CLIENTE,
    cliente,
});

// Selectors

export const getPrimeiroNomeCliente = (state: State) => {
    const cliente = getCliente(state);
    if (cliente) {
        return getPrimeiroNome(cliente.nome);
    }

    return 'Nenhum';
};

// Thunks

export const selecionarClientePorId = (id: number) => (dispatch: Function, getState: GetState) => {
    const cliente = getClientePorId(getState(), id);
    if (!cliente) {
        return;
    }

    dispatch(selecionarCliente(cliente));

    if (!getState().balcao.cliente) {
        return;
    }

    route(`/balcao/clientes/${id}/enderecos`);
};

// Reducer

const clienteReducer = (state: StateCliente = null, action: ClienteAction): StateCliente => {
    switch (action.type) {
    case SELECIONAR_CLIENTE:
        return action.cliente;
    case LIMPAR_PEDIDO:
        return null;
    case CARREGAR_PEDIDO:
        return action.pedido.usuario;
    default:
        return state;
    }
};

export default clienteReducer;
